// extracted by mini-css-extract-plugin
export default {"image":"AJaoBsJzqywu1XHFPi_q"};